import { classNames } from '@movingimage-evp/mi-ui-component-library';
import { useLocation } from 'react-router';

import { useAbsoluteRoutes } from '../../routes';

import styles from '../dev-tools.module.css';

export type ViewerState = 'loading' | 'access-denied' | 'access-code' | 'email-registration' | 'not-found';

type Props = {
  value?: ViewerState;
  onChange: (value?: ViewerState) => void;
};

export function MockedViewerState({ value, onChange }: Props) {
  const { pathname } = useLocation();
  const { viewer } = useAbsoluteRoutes();

  if (!pathname.startsWith(viewer)) return null;

  const views: ViewerState[] = ['access-code', 'email-registration', 'access-denied', 'not-found', 'loading'];

  return (
    <div className={styles.moduleWrapper}>
      <span>Viewer state</span>

      {views.map((view) => (
        <button
          key={view}
          className={classNames(value === view && styles.active)}
          onClick={() => onChange(value === view ? undefined : view)}
        >
          {view}
        </button>
      ))}
    </div>
  );
}
